import { render, staticRenderFns } from "./base-tooltip-no-data.vue?vue&type=template&id=2c42c3c7"
import script from "./base-tooltip-no-data.vue?vue&type=script&lang=js"
export * from "./base-tooltip-no-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports